import { createClient } from '@supabase/supabase-js';

// process.env sayesinde .env.local dosyasındaki gizli anahtarları çekiyoruz
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Eğer anahtarlar eksikse konsolda bizi uyarsın (Hata ayıklama için)
if (!supabaseUrl || !supabaseAnonKey) {
  console.error("L.A.G. Error: Supabase anahtarları .env.local dosyasında bulunamadı!");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);